import api from './api';

export const fetchBlogs = async () => {
  const response = await api.get('/admin/blogs');
  return response.data;
};

export const fetchBlog = async (id) => {
  const response = await api.get(`/admin/blogs/${id}`);
  return response.data;
};

/**
 * Create blog. data: title, content, blog_date, external_link?, featured_image?(File), video?(File), video_url?(string)
 */
export const createBlog = async (data) => {
  const form = new FormData();
  form.append('title', data.title || '');
  form.append('content', data.content || '');
  form.append('blog_date', data.blog_date || new Date().toISOString().slice(0, 10));
  if (data.external_link) form.append('external_link', data.external_link);
  if (data.featured_image instanceof File) form.append('featured_image', data.featured_image);
  if (data.video instanceof File) form.append('video', data.video);
  else if (data.video_url) form.append('video_url', data.video_url);

  const response = await api.post('/admin/blogs', form);
  return response.data;
};

/**
 * Update blog. data: title, content, blog_date, external_link?, featured_image?(File), video?(File), video_url?(string), remove_featured_image?(boolean), remove_video?(boolean)
 * Uses POST with _method=PUT so Laravel receives FormData (PHP does not populate input for PUT + multipart).
 */
export const updateBlog = async (id, data) => {
  const form = new FormData();
  form.append('_method', 'PUT');
  form.append('title', data.title || '');
  form.append('content', data.content || '');
  form.append('blog_date', data.blog_date || new Date().toISOString().slice(0, 10));
  form.append('external_link', data.external_link || '');
  if (data.remove_featured_image) form.append('remove_featured_image', '1');
  else if (data.featured_image instanceof File) form.append('featured_image', data.featured_image);
  if (data.remove_video) form.append('remove_video', '1');
  else if (data.video instanceof File) form.append('video', data.video);
  else if (data.video_url !== undefined) form.append('video_url', data.video_url === undefined ? '' : data.video_url);

  const response = await api.post(`/admin/blogs/${id}`, form);
  return response.data;
};

export const deleteBlog = async (id) => {
  const response = await api.delete(`/admin/blogs/${id}`);
  return response.data;
};
